/** The first seven characters of a commit, the way people read them. */
export function shortCommit(commit: string | null | undefined): string | null {
  return commit ? commit.slice(0, 7) : null;
}

/** Below `limit` seconds, count in `size`-second units. */
const UNITS: Array<{ limit: number; size: number; unit: string }> = [
  { limit: 3_600, size: 60, unit: 'minute' },
  { limit: 86_400, size: 3_600, unit: 'hour' },
  { limit: 2_592_000, size: 86_400, unit: 'day' },
  { limit: 31_536_000, size: 2_592_000, unit: 'month' },
];
const YEAR = 31_536_000;

/** "just now", "6 minutes ago", "1 hour ago", "3 days ago". A time in the future reads as "just now". */
export function relativeTime(iso: string, now: number): string {
  const seconds = Math.floor((now - new Date(iso).getTime()) / 1000);
  if (!Number.isFinite(seconds) || seconds < 60) {
    return 'just now';
  }
  const { size, unit } = UNITS.find(({ limit }) => seconds < limit) ?? { size: YEAR, unit: 'year' };
  const count = Math.floor(seconds / size);
  return `${count} ${unit}${count === 1 ? '' : 's'} ago`;
}

/** The spec's freshness line (MASTER-SPEC §14.4): "Indexed commit abc1234, 6 minutes ago". */
export function freshnessText(
  commit: string | null | undefined,
  indexedAt: string | null | undefined,
  now: number,
): string {
  const short = shortCommit(commit);
  const when = indexedAt ? relativeTime(indexedAt, now) : null;
  if (short && when) return `Indexed commit ${short}, ${when}`;
  if (short) return `Indexed commit ${short}`;
  if (when) return `Indexed ${when}`;
  return 'Indexed; the commit is not reported';
}
